// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"cec744b4b0703e8e7369","655":"f1e1c18d3a2ea008eb6a"}[chunkId] + ".js";
};